import { withScope } from "@sentry/nextjs"

import type { AppDispatch } from "../lib/store"
import type { Participant } from "@/types/api-types"

export const AUTH = "AUTH"

export type AuthAction = { type: typeof AUTH; payload: { user: Participant; token: string } | null }

export function createAuth(user: Participant, token: string) {
  return (dispatch: AppDispatch) => {
    withScope((scope) => {
      scope.setUser({ id: user.id })
    })
    localStorage.setItem("token", token)
    dispatch({
      type: AUTH,
      payload: { user, token },
    } satisfies AuthAction)
  }
}

export function logout(): AuthAction {
  withScope((scope) => {
    scope.setUser(null)
  })
  // token is the only value we still stash in localStorage directly (read by
  // the axios request interceptor before any React tree exists).
  localStorage.removeItem("token")

  return {
    type: AUTH,
    payload: null,
  }
}
